import Model from "./Model";
import Taxonomy from "@/interfaces/Taxonomy";

export default class ProductClass extends Model implements Taxonomy {
  static type = "productClasses";

  name!: string;

  get type(): string {
    return ProductClass.type;
  }
}
